import { useEffect, useState } from 'react';
import { api } from '@/utils/api';
import { useAuthStore } from '@/stores/auth';
/** Asks the server (the same rule POST /manufacturing/production-orders enforces). null = still asking; any failure or 403 = no. */
export function useCanCreateProductionOrder(): boolean | null {
  const { user } = useAuthStore();
  const identity = `${user?.tenantId}:${user?.id}:${user?.role?.name}`;
  const [state, setState] = useState<{ identity: string; allowed: boolean } | null>(null);
  useEffect(() => {
    let current = true;
    Promise.resolve().then(() => api.get('/manufacturing/production-orders/can-create'))
      .then(r => r.data?.data?.allowed === true)
      .catch(() => false)
      .then(allowed => { if (current) setState({ identity, allowed }); });
    return () => { current = false; };
  }, [identity]);
  return state?.identity === identity ? state.allowed : null;
}
